import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const PromoBlockActions = props => {
  const { className, children, ...other } = props;

  return (
    <div className={clsx("em-c-promo-block__actions", className)} {...other}>
      {children}
    </div>
  );
};

PromoBlockActions.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

PromoBlockActions.defaultProps = {
  className: "",
  children: null
};

export default PromoBlockActions;
